import { useState } from "react";
import {
  legalFormStep5FieldNames,
  PAGES,
} from "../../components/LegalForm/steps/step5/utils";

const {
  ACCOUNT_PURPOSES,
  SELECTED_COUNTRY_FROM,
  SELECTED_COUNTRY_TO,
  MONTHLY_TURNOVER,
  CASH_TURNOVER_ID,
  IS_USA_PERSON,
  DIRECTOR_IS_PEP,
  ONE_OF_BENEFICIAL_IS_PEP,
  ADDITIONAL_INFORMATION,
  ECONOMIC_ACTIVITY,
  MAIN_ECONOMIC_ACTIVITY,
  HAS_USA_TAXES,
  USA_TAXES_TYPE,
  USA_TAXES_TYPE_DESC,
  STREET_INFO,
  COUNTRY_INFO,
  ACCOUNT_NUMS,
  TIN,
  PRIVACY_AGREED,
  // kyc
  COMPANY_REGISTRATION_DATE,
  COUNTRY,
  CITY,
  STREET,
  CITY_VILLAGE,
  HOME_NUMBER,
  APARTMENT_NUMBER,
  VILLAGE,
  COMPANY_WEB_PAGE_ADDRESS,
  BUSINESS_ACTIVITY_IN_GEORGIA,
  BUSINESS_ACTIVITY_IN_GEORGIA_NO_DESCRIPTION,
  INCOME_FROM_OTHER_BUSINESS_ACTIVITIES,
  OTHER_BUSINESS_ACTIVITIES,
  CATEGORY_OF_POLITICALLY_EXPOSED,
  EXPORT_CONNECTIONS,
  IS_COMPANY_EXP_IMP,
  INFO_COUNTERPARTIES,
  CAPITAL_SOURCES,
  CAPITAL_SOURCES_IN_BANK,
  CAPITAL_SOURCES_IN_BANK_OTHER,
  WHERE_YOU_HAVE_BANK_ACCOUNTS,
  PLEASE_SPECIFY_BANKS,
  MONEY_SOURCES,
  PLEASE_SPECIFY_INCOME_SOURCE,
  WEALTH_SOURCES,
  PLEASE_SPECIFY_WEALTH,
  INFORMATION_ABOUT_RELATED_PEP,
  CONFIRMATION_STATUS,
  COMPANY_JURIDICAL_ADDRESS,
  OWNERS_INFO,
  PAGE,
  CONFIRM_KYC,
} = legalFormStep5FieldNames;

const initAddress = {
  [COUNTRY]: "",
  [CITY]: "",
  [STREET]: "",
  [CITY_VILLAGE]: "",
  [HOME_NUMBER]: "",
  [APARTMENT_NUMBER]: "",
  [VILLAGE]: "",
};

const initialValues = {
  [SELECTED_COUNTRY_FROM]: [],
  [SELECTED_COUNTRY_TO]: [],
  [ACCOUNT_PURPOSES]: [],
  [MONTHLY_TURNOVER]: "",
  [CASH_TURNOVER_ID]: "",
  [IS_USA_PERSON]: "no",
  [DIRECTOR_IS_PEP]: "no",
  [ONE_OF_BENEFICIAL_IS_PEP]: "no",
  [ECONOMIC_ACTIVITY]: [],
  [ADDITIONAL_INFORMATION]: "",
  [MAIN_ECONOMIC_ACTIVITY]: "",
  [HAS_USA_TAXES]: "no",
  [USA_TAXES_TYPE]: "",
  [USA_TAXES_TYPE_DESC]: "",
  [STREET_INFO]: "",
  [COUNTRY_INFO]: "",
  [TIN]: "",
  [ACCOUNT_NUMS]: "",
  [PRIVACY_AGREED]: false,
  // kyc
  [COMPANY_REGISTRATION_DATE]: "",
  [COMPANY_WEB_PAGE_ADDRESS]: "",
  [BUSINESS_ACTIVITY_IN_GEORGIA]: "yes",
  [BUSINESS_ACTIVITY_IN_GEORGIA_NO_DESCRIPTION]: "",
  [INCOME_FROM_OTHER_BUSINESS_ACTIVITIES]: "",
  [OTHER_BUSINESS_ACTIVITIES]: "",
  [CATEGORY_OF_POLITICALLY_EXPOSED]: "0",
  [EXPORT_CONNECTIONS]: "",
  [IS_COMPANY_EXP_IMP]: "no",
  [INFO_COUNTERPARTIES]: "",
  [CAPITAL_SOURCES]: [],
  [CAPITAL_SOURCES_IN_BANK]: [],
  [CAPITAL_SOURCES_IN_BANK_OTHER]: "",
  [WHERE_YOU_HAVE_BANK_ACCOUNTS]: [],
  [PLEASE_SPECIFY_BANKS]: "",
  [MONEY_SOURCES]: [],
  [PLEASE_SPECIFY_INCOME_SOURCE]: "",
  [WEALTH_SOURCES]: [],
  [PLEASE_SPECIFY_WEALTH]: "",
  [INFORMATION_ABOUT_RELATED_PEP]: "",
  [CONFIRMATION_STATUS]: false,
  [COMPANY_JURIDICAL_ADDRESS]: { ...initAddress },
  [PAGE]: PAGES.mainFrom,
  [CONFIRM_KYC]: false,
};

function useStepFiveValues() {
  const [stepFiveValues, setStepFiveValues] = useState(initialValues);
  return { stepFiveValues, setStepFiveValues };
}

export default useStepFiveValues;
